/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__route_selector__column_emission = /** @type {(inputs: {}) => string} */ () => {
	return `CO2-Emissionen`
};

const en_route__route_selector__column_emission = /** @type {(inputs: {}) => string} */ () => {
	return `CO2 emissions`
};

const es_route__route_selector__column_emission = /** @type {(inputs: {}) => string} */ () => {
	return `Emisiones de CO2`
};

const fr_route__route_selector__column_emission = /** @type {(inputs: {}) => string} */ () => {
	return `Émissions CO2`
};

const it_route__route_selector__column_emission = /** @type {(inputs: {}) => string} */ () => {
	return `Emissioni di CO2`
};

const nl_route__route_selector__column_emission = /** @type {(inputs: {}) => string} */ () => {
	return `CO2-emissies`
};

const pt_route__route_selector__column_emission = /** @type {(inputs: {}) => string} */ () => {
	return `Emissões de CO2`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_emission = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__route_selector__column_emission(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__route_selector__column_emission", locale)
	if (locale === "de") return de_route__route_selector__column_emission(inputs)
	if (locale === "en") return en_route__route_selector__column_emission(inputs)
	if (locale === "es") return es_route__route_selector__column_emission(inputs)
	if (locale === "fr") return fr_route__route_selector__column_emission(inputs)
	if (locale === "it") return it_route__route_selector__column_emission(inputs)
	if (locale === "nl") return nl_route__route_selector__column_emission(inputs)
	return pt_route__route_selector__column_emission(inputs)
};